import React from 'react';
import ReactSelectize from 'react-selectize';
import { partitionString } from 'prelude-extension';

const highlightStyle = {
    backgroundColor: "rgba(255,255,0,0.4)",
    fontWeight: "bold"
};

class ValueReference extends React.Component {
    constructor(props) {
        super(props);

        this.onExpand = this.onExpand.bind(this);
    }

    getDetails(contentType, type, service, search) {
        // The maximum details for an Object appear as such: 
        // [Object/List/String/Boolean] [[of ]TypeName] [from ServiceName] / [Object/List/String/Boolean] [[of ]TypeName] [from ServiceName]
        // Most complex Value: Object of User from Salesforce / Object of User from Salesforce
        // Most simple Value with property: Object of CustomObjectWithBooleanProperty / Boolean
        // Most simple Value: String
        const details = [];

        // This shows the intiial [Object/List/String/Boolean]
        if (type && contentType && !manywho.utils.isNullOrWhitespace(contentType.contentValue)) {
            details.push(<span key={type.contentValue}>{contentType.contentValue.replace('Content', '')}</span>);
        }

        // The UI should treat the contentType (ContentString, ContentBoolean, ContentObject etc.) as the primary information for the type of a Value
        // If the engine gives back a primitive type, we should ignore any Type it gives back
        // Hence, we are not showing the incorrectly given [TypeName] or [ServiceName] (because Primitives do not come from Services)
        if (contentType && (contentType.contentValue === 'ContentObject' || contentType.contentValue === 'ContentList')) {
            if (type && !manywho.utils.isNullOrWhitespace(type.contentValue)) {
                if (!manywho.utils.isNullOrWhitespace(search) && type.contentValue.toLowerCase().indexOf(search.toLowerCase()) !== -1) {
                    // This shows the [TypeName] in yellow because the Type was searched for
                    details.push(
                        <ReactSelectize.HighlightedText
                            key='search'
                            partitions={partitionString(type.contentValue.toUpperCase(), search.toUpperCase())}
                            text={type.contentValue}
                            highlightStyle={highlightStyle} 
                        />
                    );
                } else {
                    // This shows the [of TypeName]
                    details.push(<span key='type'>{' of ' + type.contentValue}</span>);
                }
            }

            // This shows the [from ServiceName]
            if (service && !manywho.utils.isNullOrWhitespace(service.contentValue) && type && !manywho.utils.isNullOrWhitespace(type.contentValue)) {
                details.push(<span key='service'>{' from ' + service.contentValue}</span>);
            }
        }

        return details;
    }

    onExpand(e) {
        e.preventDefault();
        e.stopPropagation();

        this.props.onExpand(e.target.id);
    }

    render() {
        if (this.props.reference) {
            let developerName = manywho.utils.getObjectDataProperty(this.props.reference.properties, 'DeveloperName').contentValue;
            const id = manywho.utils.getObjectDataProperty(this.props.reference.properties, 'Id').contentValue;
            const propertyId = manywho.utils.getObjectDataProperty(this.props.reference.properties, 'TypeElementPropertyId').contentValue;
            const property = manywho.utils.getObjectDataProperty(this.props.reference.properties, 'TypeElementPropertyDeveloperName').contentValue;
            const contentType = manywho.utils.getObjectDataProperty(this.props.reference.properties, 'ContentType');
            const type = manywho.utils.getObjectDataProperty(this.props.reference.properties, 'TypeElementDeveloperName');
            const service = manywho.utils.getObjectDataProperty(this.props.reference.properties, 'ServiceElementDeveloperName');
            const propertyType = manywho.utils.getObjectDataProperty(this.props.reference.properties, 'TypeElementEntryTypeElementDeveloperName');
            const parentContentType = manywho.utils.getObjectDataProperty(this.props.reference.properties, 'ParentContentType');

            let edit = null;
            if (!parentContentType || manywho.utils.isNullOrWhitespace(parentContentType.contentValue) && this.props.onEdit)
                edit = <a id={this.props.reference.externalId} onClick={this.props.onEdit}>Edit</a>;

            let showProperties = null;
            if (this.props.onExpand && type && !manywho.utils.isNullOrWhitespace(type.contentValue) && manywho.utils.isNullOrWhitespace(property))
                showProperties =<a id={this.props.reference.externalId} onClick={this.onExpand}>{'Show the properties for this ' + contentType.contentValue.replace('Content', '')}</a>;

            let name = null;
            if (!manywho.utils.isNullOrWhitespace(property))
                developerName = developerName + ' / ' + property;

            if (!manywho.utils.isNullOrWhitespace(this.props.search)
                && developerName.substr(0, 1) !== '$'
                && developerName.toLowerCase().indexOf(this.props.search.toLowerCase()) !== -1)                    
                name = <ReactSelectize.HighlightedText partitions={partitionString(developerName.toUpperCase(), this.props.search.toUpperCase())}
                                                        text={developerName}
                                                        highlightStyle={highlightStyle} />;
            else
                name = <span className="value-reference-name">{developerName}</span>;

            let details = null;

            if (manywho.utils.isNullOrWhitespace(property))
                details = this.getDetails(contentType, type, service, this.props.search);
            else
                details = this.getDetails(parentContentType, type, service, this.props.search)
                            .concat([<span key='divider'> / </span>])
                            .concat(this.getDetails(contentType, propertyType, service, this.props.search));           

            return <div key={id + propertyId}>
                <div className="value-reference" onClick={this.props.onClick} key={'reference-' + this.props.reference.externalId}>
                    {name}
                    <span className="value-reference-details">{details}</span>
                    <div className="value-reference-edit">
                        {edit}
                        {showProperties && edit ? <span>|</span> : null}
                        {showProperties}
                    </div>                    
                </div>
                 {(this.props.isSelected) ? <span className="glyphicon glyphicon-ok" title="Selected"/> : null}
            </div>;
        }

        return null;
    }
}

export default ValueReference;
